import * as React from "react";
import { DatePicker } from "@/src/components/input/date-picker";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsDatePicker() {
  const code = `import { DatePicker } from "@/src/components/input/date-picker";
import * as React from "react";

export function DatePickerDemo() {
  const [date, setDate] = React.useState<Date | null>(null);

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <DatePicker
        value={date}
        onChange={setDate}
        placeholder="Choose a date"
      />
      <DatePicker
        value={date}
        onChange={setDate}
        placeholder="Choose another date"
      />
    </div>
  );
}`;

  const installCommand = `npm install`;

  return (
    <ComponentPage
      title="Date Picker"
      description="Accessible date picker for selecting single dates."
      preview={
        <div className="grid gap-4 sm:grid-cols-2 w-full">
          <DatePicker
            placeholder="Choose a date"
          />
          <DatePicker
            placeholder="Choose another date"
          />
        </div>
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "DatePickerProps",
        props: [
          {
            name: "value",
            type: "Date | null",
            description: "Controlled date value.",
          },
          {
            name: "defaultValue",
            type: "Date | null",
            description: "Uncontrolled initial date value.",
          },
          {
            name: "onChange",
            type: "(value: Date | null) => void",
            description: "Callback when date changes.",
          },
          {
            name: "placeholder",
            type: "string",
            description: "Placeholder text shown when no date selected.",
          },
          {
            name: "disabled",
            type: "boolean",
            description: "Whether the date picker is disabled.",
          },
          {
            name: "className",
            type: "string",
            description: "Additional CSS classes for the wrapper.",
          },
        ],
      }}
    />
  );
}

